export const MODULE_NAME = 'advanced-preview';
export const ADVANCED_PREVIEW_ROUTE = `/${MODULE_NAME}`;
